var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57975 7.69925C5.59325 7.71125 5.606 7.7225 5.61875 7.736C6.428 8.5655 6.87425 9.66425 6.87425 10.8305V13.8185L8.55125 12.905C8.68325 12.833 8.765 12.692 8.765 12.5367V10.8215C8.765 9.65975 9.20675 8.56475 10.0085 7.73975L13.6363 3.881C13.871 3.63125 14 3.3035 14 2.95775V2.25575C14 1.90775 13.7255 1.625 13.3895 1.625H2.23625C1.8995 1.625 1.625 1.90775 1.625 2.25575V2.95775C1.625 3.3035 1.754 3.63125 1.98875 3.88025L5.57975 7.69925ZM6.6095 15.1257C6.458 15.1257 6.308 15.0852 6.1715 15.0042C5.9075 14.8467 5.74925 14.5685 5.74925 14.2595V10.8305C5.74925 9.97925 5.432 9.1775 4.85375 8.56325C4.8365 8.549 4.81925 8.53325 4.80425 8.51675L1.16975 4.652C0.73775 4.193 0.5 3.59075 0.5 2.95775V2.25575C0.5 1.2875 1.27925 0.5 2.23625 0.5H13.3895C14.3457 0.5 15.125 1.2875 15.125 2.25575V2.95775C15.125 3.59 14.8873 4.1915 14.4568 4.65125L10.8215 8.51675C10.2193 9.13775 9.89 9.9545 9.89 10.8215V12.5367C9.89 13.1037 9.58325 13.6227 9.08975 13.8927L7.019 15.0207C6.89 15.0905 6.74975 15.1257 6.6095 15.1257Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e4be497d.svg";
export { ForwardRef as ReactComponent };